/**
 * created by wang lei
 合并多个单元格 页面
 *
 */
import React, {Component} from 'react';
import mergeCells from './mergeCells.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class MergeCellsTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mergecells:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let mergecells = this.props.editor.queryCommandState("mergecells");
        this.setState({mergecells: mergecells === 0});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let mergecells = this.props.editor.queryCommandState("mergecells");
        this.setState({mergecells: mergecells === 0});
    }
    render() {
        return (
            <span style={{cursor:"pointer",opacity:this.state.mergecells ? "1":"0.3"}}>
                <img className={"editor-merge-cells-tool-btn"} src={mergeCells} onClick={()=>this.props.editor.execCommand("mergecells")}/>
                {this.state.mergecells ? <style>{`
                .editor-merge-cells-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-merge-cells-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-merge-cells-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> : <style>{`
                .editor-merge-cells-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-merge-cells-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-merge-cells-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>}

            </span>
        )
    }

}